import { Languages, Compass, Clock } from "lucide-react";

const ICONS = [Languages, Compass, Clock];

export const TrustBar = ({ label, items }) => (
  <section data-testid="trust-bar" aria-label={label} className="container-x pb-14 sm:pb-20">
    <ul className="grid gap-8 md:grid-cols-3 md:gap-10">
      {items.map((x, i) => {
        const Icon = ICONS[i % ICONS.length];
        return (
          <li key={x.title} data-testid={`trust-bar-item-${i}`} className="flex gap-4 border-t border-forest/15 pt-6">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ivory-2 text-forest">
              <Icon size={18} aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-display text-2xl leading-tight text-forest">{x.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-forest/75">{x.text}</p>
            </div>
          </li>
        );
      })}
    </ul>
  </section>
);
